import { createContext } from 'react';

export const initialState = {
  themeColor: 'secondary.dark',
  offerType: 'SIM only - 1 month',
  offers: [],
  devices: [],
  simOnly: true,
};

export const mobileOfferReducer = (state, action) => {
  switch (action.type) {
    case 'themeColor': {
      return {
        ...state,
        themeColor: action.payload,
      };
    }
    case 'offerType': {
      return {
        ...state,
        offerType: action.payload,
      };
    }
    case 'offers': {
      return {
        ...state,
        offers: action.payload,
      };
    }
    case 'devices': {
      return {
        ...state,
        devices: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
export const MobileOfferContext = createContext();
